// The current file development is no longer in active phase but the code will be kept as is.
// Please be advised that we have discontinued the sync for this file with the commercial version of Kendo UI for jQuery.
// To take advantage of new features please visit (https://www.telerik.com/kendo-jquery-ui) and consider upgrading to a commercial license.
const addWatermarkOverlayAndBanner = () => { };
const setScriptKey = () => { };
const packageMetadata = {
    version: "$KENDO_VERSION".replace(/^\s+|\s+$/g, '')
}

export { setScriptKey, addWatermarkOverlayAndBanner, packageMetadata };